import { lazy } from 'react';
import { melioIcon } from '@tools/ui/assets';
import type { AppRouter } from '@tools/ui/types';

export const BASE_PATH = '/xero-test-app';

const MainView = lazy(
  () => import(/* webpackChunkName: "XeroTestAppRoutes" */ '../pages/MainView')
);

const OnboardingView = lazy(
  () =>
    import(
      /* webpackChunkName: "XeroTestAppRoutes" */ '../pages/OnboardingView'
    )
);

const BillsOverview = lazy(
  () =>
    import(/* webpackChunkName: "XeroTestAppRoutes" */ '../pages/BillsOverview')
);

const PaymentFlow = lazy(
  () =>
    import(/* webpackChunkName: "XeroTestAppRoutes" */ '../pages/PaymentFlow')
);

export const xeroTestAppRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [BASE_PATH, `${BASE_PATH}/*`]
    },
    {
      name: 'Xero test app',
      path: `${BASE_PATH}/main`,
      component: MainView,
      exact: false,
      icon: melioIcon,
      pages: []
    },
    {
      name: 'Onboarding',
      path: `${BASE_PATH}/onboarding`,
      component: OnboardingView,
      exact: false,
      icon: melioIcon,
      pages: []
    },
    {
      name: 'Bills Overview',
      path: `${BASE_PATH}/bills`,
      component: BillsOverview,
      exact: false,
      icon: melioIcon,
      pages: []
    },
    {
      name: 'Payment Flow',
      path: `${BASE_PATH}/payment`,
      component: PaymentFlow,
      exact: false,
      icon: melioIcon,
      pages: []
    }
  ]
};
